// extracted by mini-css-extract-plugin
export default {"wrapper":"testimonial_wrapper__KQHKK","card_container":"testimonial_card_container__Y73yW","content":"testimonial_content__k-6Kr","img_part":"testimonial_img_part__dFWwM"};